module.exports = __webpack_public_path__ + "static/twitter-fb6ca24911710c6cc8355e4e1a574fc2.jpg";